module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/boolbase/index.js
// module id = 111
// module chunks = 0